import React, { useMemo } from 'react';
import { CARD_TYPES, PAYMENT_METHOD_TYPE } from 'constants/common';
import cn from 'classnames';
import Icon, { MasterLightIcon, VisaLightIcon } from 'components/Atoms/Icon';

import Skeleton from 'react-loading-skeleton';
import './styles.scss';

const formatExpriry = (month, year) =>
  month && year ? [month, year].join('/') : 'N/A';

export const CardInfoSkeleton = () => {
  return (
    <div className="card-wrapper py-10 no-background">
      <Skeleton width="100%" height="209px" />
    </div>
  );
};

const CardInfo = ({
  brand,
  bankName,
  cardName,
  cardType,
  expirationMonth,
  expirationYear,
  funding,
  last4,
  status,
  type,
  className,
}) => {
  const expiryDate = useMemo(() => {
    return formatExpriry(expirationMonth, expirationYear);
  }, [expirationMonth, expirationYear]);

  const renderLogo = useMemo(
    () =>
      type === PAYMENT_METHOD_TYPE.ACH_ACCOUNT ? (
        'ACH'
      ) : brand === CARD_TYPES.VISA ? (
        <Icon component={VisaLightIcon} />
      ) : (
        <Icon component={MasterLightIcon} />
      ),
    [brand]
  );

  const isNewACH = useMemo(() => {
    return type === PAYMENT_METHOD_TYPE.ACH_ACCOUNT && status === 'new';
  }, [type, status]);

  const cls = useMemo(() => {
    return cn('card-wrapper', type?.toLowerCase(), brand, status, className);
  }, [type, brand, status, className]);

  return (
    <div id="card-info">
      <div className={cls}>
        <div className="card-header flex-space-between">
          <div className="title">{bankName}</div>
          <div className="title">{renderLogo}</div>
        </div>
        <div className="card-number">**** **** **** {last4}</div>
        <div className="card-footer flex-space-between">
          <div className="left-desc">
            <p className="sub-title">Card name</p>
            <p className="title">{cardName}</p>
          </div>
          <div className="right-desc">
            <p className="sub-title">Expiry Date</p>
            <p className="title">{expiryDate}</p>
          </div>
        </div>
        {isNewACH && <div className="ach-overlay" />}
      </div>
    </div>
  );
};

export default CardInfo;
